// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useState } from "react";
import { useCallback } from "react";
import StudentGridItem from "../front/StudentGridItem";
import Error from "../../../../components/Error";
import Grid from "@material-ui/core/Grid";
import { Form } from "react-final-form";
import FilterForm from "./FilterForm";
import { useAuth } from "../../../auth/hooks/useAuth";
import UserListItem from "../admin/UserListItem";

interface StudentsListProps {
  students;
  refetch?: Function;
}

const StudentsList: FC<StudentsListProps> = ({ students, refetch }) => {
  const { user } = useAuth();
  const [results, setResults] = useState(students);

  const handleSubmit = useCallback(
    ({ country, studentType, keyword }) => {
      let res = students;

      if (country) {
        res = res.filter(
          (user) =>
            user.studentProfile?.country &&
            user.studentProfile.country.toLowerCase() ===
              country.code.toLowerCase(),
        );
      }
      if (studentType) {
        if (studentType.id === "onlyRegistered") {
          res = res.filter((user) => !user.studentProfile?.agent);
        }

        if (studentType.id === "onlyCreatedByAgent") {
          res = res.filter((user) => user.studentProfile?.agent);
        }
      }
      if (keyword) {
        res = res.filter((user) =>
          user.name.toLowerCase().includes(keyword.toLowerCase()),
        );
      }
      setResults(res);
    },
    [students],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} component={FilterForm} />
      <Grid container spacing={2}>
        {results.length ? (
          results.map((student) =>
            user.role < 2 ? (
              <UserListItem
                key={`StudentGridItem_${student.id}`}
                user={student}
                refetch={refetch}
              />
            ) : (
              <StudentGridItem
                student={student}
                key={`StudentGridItem_${student.id}`}
              />
            ),
          )
        ) : (
          <Error text={"No students found"} />
        )}
      </Grid>
    </>
  );
};

export default React.memo(StudentsList);
